import { Actions } from "./companyConstants";
import produce from "immer";

const initialState = {
  data: null,
  loading: false,
  uploading: false,
  operationResult: null,
};

export const reducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case Actions.READ_COMPANY:
        draft.loading = true;
        draft.data = null;
        return draft;

      case Actions.READ_COMPANY_SUCCEEDED:
        draft.loading = false;
        draft.data = action.payload.Data;
        draft.operationResult =
          action.payload.Operation.Outcome !== "Success"
            ? action.payload.Operation
            : null;
        return draft;

      case Actions.UPDATE_COMPANY:
        draft.loading = true;
        draft.operationResult = null;
        return draft;

      case Actions.UPDATE_COMPANY_SUCCEEDED:
        if (action.payload.Operation.Outcome === "Success") {
          draft.data = action.payload.Data;
        }
        draft.operationResult = action.payload.Operation;
        draft.loading = false;
        return draft;

      case Actions.UPLOAD_CONTRACT:
        draft.uploading = true;
        draft.operationResult = null;
        return draft;

      case Actions.UPLOAD_CONTRACT_SUCCEEDED:
        draft.uploading = false;
        if (action.payload.Operation?.Outcome === "Success") {
          draft.data = action.payload.Data;
        }
        draft.operationResult = action.payload.Operation;
        return draft;

      case Actions.CLEAR_OPERATION_RESULT:
        draft.operationResult = null;
        return draft;

      default:
        return state;
    }
  });
};
